import home from '../assets/images/Sidebar Icon/home.png';
import item from '../assets/images/Sidebar Icon/item.png';
import scan from '../assets/images/Sidebar Icon/scan.png';
import past from '../assets/images/Sidebar Icon/past.png';
import logisticImage from '../assets/images/Sidebar Icon/logistic.png';
import company from '../assets/images/Sidebar Icon/company.png';
import warehouse from '../assets/images/Sidebar Icon/warehouse.png';

const warehousesidebar = [
    {
        navigation: "/home",
        icon: home,
        label: "Home",
    },
    {
        navigation: "/products",
        icon: item,
        label: "Product",
    },
    {
        navigation: "/scanbarcode",
        icon: scan,
        label: "Scan Barcode",
    },
    {
        navigation: "/pasttransactions",
        icon: past,
        label: "Past Transactions",
    },
    {
        navigation: "/logistic",
        icon: logisticImage,
        label: "Logistic Staff",
    },
    {
        navigation: "/company",
        icon: company,
        label: "Company",
    },
    {
        navigation: "/warehouse",
        icon: warehouse,
        label: "Warehouse",
    }
]

export { warehousesidebar };